<template>
  <footer class="footer">
    <div class="container justify-content-center">
    
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
